import { render, staticRenderFns } from "./work-phone-query.vue?vue&type=template&id=46274556"
import script from "./work-phone-query.vue?vue&type=script&lang=ts"
export * from "./work-phone-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports